/**
 * Photo — background art with the duotone scrim over it.
 *
 * Hero banners, campaign cards, activity thumbnails. The scrim is what makes
 * the title on top readable whatever the image is, so the two belong together:
 * every call site used to pass the image through an inline `backgroundImage`
 * and remember to add the `.photo` class that draws the scrim.
 *
 * With no `src` it renders as a plain recessed panel, which is the placeholder
 * the student area already relied on.
 */

import type { ReactNode } from 'react';
import styles from './photo.module.css';

interface PhotoProps {
  /** Image URL. Omit for the placeholder panel. */
  src?: string | null;
  /** Content laid over the art — a status pill, a title. */
  children?: ReactNode;
  /** Fill the positioned parent — the hero banners' background art. */
  fill?: boolean;
  className?: string;
}

export function Photo({ src, children, fill, className }: PhotoProps) {
  return (
    <div
      className={[styles.photo, fill ? styles.fill : null, className].filter(Boolean).join(' ')}
      // The one legitimate inline style here: the URL is data, not design.
      style={src ? { backgroundImage: `url(${src})` } : undefined}
    >
      {children}
    </div>
  );
}
